import { mapState } from 'vuex'

export const preferencesMixin = {
  computed: {
    ...mapState({
      preferences: state => state.report.reportPreferences,
    }),
  },
}

export default preferencesMixin
